import { useId, useState } from 'react';

export const Accordion = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const panelId = useId();

  return (
    <div
      style={{
        maxWidth: '600px',
        margin: '0 auto 12px',
        border: '1px solid var(--color-border)',
        borderRadius: 'var(--radius-md)',
        overflow: 'hidden',
        boxShadow: isOpen ? 'var(--shadow-md)' : 'var(--shadow-sm)',
        fontFamily: 'sans-serif',
        transition: 'box-shadow 0.25s ease',
      }}
    >
      <h3 style={{ margin: 0, fontSize: 'inherit', fontWeight: 'inherit' }}>
        <button
          onClick={() => setIsOpen(!isOpen)}
          aria-expanded={isOpen}
          aria-controls={panelId}
          style={{
            width: '100%',
            padding: '1rem 1.5rem',
            background: isOpen ? 'var(--color-surface-muted)' : '#fff',
            color: 'var(--color-text)',
            fontWeight: 700,
            fontSize: '1.1rem',
            border: 'none',
            cursor: 'pointer',
            textAlign: 'left',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '1rem',
            transition: 'background 0.25s ease',
          }}
        >
          {title}
          <span
            aria-hidden="true"
            style={{
              flexShrink: 0,
              color: 'var(--color-primary-text)',
              transform: isOpen ? 'rotate(90deg)' : 'rotate(0)',
              transition: '0.3s',
            }}
          >
            ▶
          </span>
        </button>
      </h3>

      {isOpen && (
        <div
          id={panelId}
          role="region"
          style={{
            padding: '1rem 1.5rem',
            backgroundColor: '#fff',
            color: 'var(--color-text-muted)',
            lineHeight: '1.5rem',
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};
